// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  youtubeUrl: "https://www.youtube.com/watch?v=",
  url: "http://localhost:4200",
  API_URL: "https://api3.zavedenia.com/v3/",
  // AGM_KEY: "AIzaSyBJ44S3jgbfusYXf8R76oAmKCpOAe6jOCg",
  AGM_KEY: "AIzaSyBF65uYex9jFPSfrj3exjSBZa1LtS-c-jk",
  MOBIBLE_API_URL: "https://zavedenia.com/apps/mobile/API_V2/index.php",
  BANNERS_API_URL: "https://zavedenia.com/zavedenia-banners/api/zavedeniaSPAHomeBanners.php",
  BANNERS3_API_URL: "https://zavedenia.com/zavedenia-banners/api/zavedeniaSPAHomeBanners3.php",
  BANNERS2_API_URL: "https://zavedenia.com/zavedenia-banners/api/banners2.php",
  zavMaps: "AIzaSyDwOuBict4PLgMqTCvxUbVwPgrBVNUNgq8"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
